import { collection, documentId, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';

const TEMPLATE_CACHE_TTL_MS = 5 * 60 * 1000;
const templateCache = new Map();

const chunk = (arr, size = 10) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

function getCachedTemplate(id, now = Date.now()) {
  const key = String(id || '');
  if (!key) return null;
  const entry = templateCache.get(key);
  if (!entry) return null;
  if (now - entry.ts > TEMPLATE_CACHE_TTL_MS) {
    templateCache.delete(key);
    return null;
  }
  return entry.row || null;
}

export function primeBookTemplatesCache(rows = []) {
  if (!rows.length) return;
  const ts = Date.now();
  rows.forEach((row) => {
    if (!row?.id) return;
    templateCache.set(String(row.id), { ts, row });
  });
}

export async function loadBookTemplatesByIds(ids = []) {
  const uniqueIds = Array.from(new Set((ids || []).filter(Boolean).map((x) => String(x))));
  if (!uniqueIds.length) return [];

  const now = Date.now();
  const out = [];
  const missing = [];

  uniqueIds.forEach((id) => {
    const cached = getCachedTemplate(id, now);
    if (cached) out.push(cached);
    else missing.push(id);
  });

  for (const pack of chunk(missing, 10)) {
    if (!pack.length) continue;
    const snap = await getDocs(
      query(collection(db, 'bookTemplates'), where(documentId(), 'in', pack))
    );
    const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    primeBookTemplatesCache(rows);
    out.push(...rows);
  }

  return out;
}

